import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";
import { AppDispatch } from "../../../store";
import { APIError } from "../../../core/types";
import { LocalStorageManager } from "../../../core/storage/LocalStorageManager";
import { AppConfig } from "../../../AppConfig";
import { CookieManager } from "../../../core/storage/CookieManager";
import { ErrorMessageManager } from "../../../core/http/ErrorMessageManager";

export const useLoginPassword = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { navigateToPage } = useNavigation();
  const { state } = useLocation();
  const { email, hasPhone } = state ?? {};

  useEffect(() => {
    if (!email) navigateToPage(PageRoutes.LOGIN);
  }, [email]);

  const handleLoginPassword = useCallback((password: string) => {
    dispatch(appActions.showLoading());

    dispatch(
      authActions.loginWithPassword.started({
        email,
        password,
        onComplete: () => dispatch(appActions.hideLoading()),
        onSuccess: ({ phone_number, session_token }) => {
          if (hasPhone) {
            navigateToPage(PageRoutes.SMS_SEND, false, {
              password,
              phoneNumber: phone_number,
              token: session_token,
            });
          } else {
            navigateToPage(PageRoutes.EMAIL_SEND, false, {
              password,
              email,
              token: session_token,
            });
          }
        },
        onError: (error: APIError | undefined) => {
          const errorMessage: string =
            ErrorMessageManager.Instance.getErrorMessage(
              error?.response?.data["error-code"]
                ? error?.response?.data["error-code"]
                : "unauthorized",
            );
          dispatch(
            appActions.showModal({
              title: errorMessage,
              buttons: [
                {
                  variant: "dark",
                  text: "閉じる",
                  onClick: () => {
                    dispatch(appActions.hideModal());
                  },
                },
              ],
            }),
          );
        },
      }),
    );
  }, []);

  const handleForgotPassword = useCallback(() => {
    navigateToPage(PageRoutes.FORGOT_PASSWORD, false, { email });
  }, []);

  const handleBack = useCallback(() => {
    navigateToPage(PageRoutes.LOGIN);
  }, []);

  return { handleLoginPassword, handleForgotPassword, handleBack };
};
